module.exports = __webpack_public_path__ + "static/img/new3.5b7f64e8.png";